module.exports = __webpack_public_path__ + "img/calculo-de-blindaje.0608a176.jpg";